import { RouteConfig } from "vue-router";
import Store from "@/store";
import { UserType } from "@/config";

const changeTenant: RouteConfig[] = [
  {
    path: "/change-tenant",
    name: "ChangeTenant",
    component: () => import("@/views/auth/ChangeTenant.vue"),
    beforeEnter: (_to, _from, next) => {
      const userType = Store.getters.user?.userType || 0;
      if (userType === UserType.CSR) {
        localStorage.removeItem("activeTenantId");
        localStorage.removeItem("activeTenant");
        const anyStore = Store as any;
        const mutations = anyStore?._mutations || {};
        if (mutations["setActiveTenantId"]) anyStore.commit("setActiveTenantId", 0);
        if (mutations["auth/setActiveTenantId"]) anyStore.commit("auth/setActiveTenantId", 0);
      }
      next();
    },
    meta: {
      appClass: "tenant-mode",
      appBar: "user",
      navDrawer: false,
      title: "Change Tenant",
      hideAdminMenu: true,
      disableHomeNav: true,
    },
  },
];

export default changeTenant;
